import theme from '@css/theme';
import styled from 'styled-components';

export const TooltipContainer = styled.span`
  margin-left: ${theme.token.marginXXS}px;
`;
